export const appColor = {
  App: {
    primary: "#32D3EB",
    accent: "#DE3E44",
    white: "#FFFFFF",
    welcome: "linear-gradient(240.63deg, #32d3eb 13.44%, #3ab7ff 95.5%)",
  },
  Text: {
    primary: "#2B2A27", // 主にメインテキストなどに使用
    secondary: "#93918F", // 非アクティブ要素や注釈のテキストなどに使用
    white: "#FFFFFF",
  },
  Border: {
    primary: "#2B2A27", // Divider/Border/Strokeが主にアクティブなときに使用
    secondary: "#F4F4F4", // Divider/Border/Strokeが主に非アクティブなときに使用
    third: "#F1F1F1",
  },
  Background: {
    primary: "#FFFFFF", // メインバックグラウンドで使用
    secondary: "#F7F7F7", // サブコンテンツのバックグラウンドで使用
    selected: "#FCFCFE", // リストアイテムなどが選択状態のときに使用
    welcome: "#F9FDFF",
    third: "#F4F4F4",
    chat: "#F8FAFB",
  },
  Form: {
    primary: "#FFFFFF", // 活性状態のときに使用
    secondary: "#FCFCFE", // 非活性状態のときに使用
  },
  Button: {
    primary: {
      color: "#2B2A27",
      text: "#FFFFFF",
    }, // メインボタン
    negative: {
      color: "#F4F3F8",
      text: "#B4B4BE",
    }, //主にボタンが非アクティブ状態で使用
    accent: {
      red: "#FF7663",
      gray: "#7F7F89",
      facebook: "#1877F2",
    },
    social: {
      facebook: "#5E6E9F",
    },
  },
  Accent: {
    blue: "#3AB7FF",
    lightblue: "#32D3EB",
    ultraLightBlue: "#DEF8FC",
    orange: "#FFAA4E",
    red: "#FF7663",
    yellow: "#FBC929",
    gray: "#93918F",
    green: "#7CBC93",
  },
} as const;
